import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TeacherApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    qualification: "",
    experience: "",
    subject: "",
    address: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);

  // Handle input changes for text fields and file upload
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0], // Store the selected file in state
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Create FormData object to send form data, including file
    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("qualification", formData.qualification);
    data.append("experience", formData.experience);
    data.append("subject", formData.subject);
    data.append("address", formData.address);
    data.append("resume", formData.resume);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/recruitment/create`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Application submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        qualification: "",
        experience: "",
        subject: "",
        address: "",
        resume: null,
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4 sm:p-6 md:p-10">
      <motion.div
        className="bg-white shadow-lg rounded-lg p-6 w-full max-w-2xl border-4 border-teal-500" // Added border here
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Banner Section */}
        <div className="relative w-full h-64 bg-gradient-to-r from-blue-600 via-teal-500 to-green-400 text-white text-center rounded-lg shadow-lg mb-8">
          <img
            src="https://t4.ftcdn.net/jpg/05/44/05/75/360_F_544057533_blcaNHoILPyw01zcGBz4eGLMVAQIIFRz.jpg"
            alt="Teacher Recruitment"
            className="w-full h-full object-cover rounded-lg opacity-50"
          />
          {/* <div className="absolute inset-0 flex justify-center items-center text-center p-4">
            <h1 className="text-4xl font-bold">Teacher Recruitment</h1>
            <p className="mt-4 text-xl">Join us to shape the future of education!</p>
          </div> */}

          <div className="absolute inset-0 flex flex-col sm:flex-row justify-center items-center text-center p-4 sm:p-6 md:p-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">Teacher Recruitment</h1>
            <p className="mt-2 sm:mt-0 sm:ml-4 text-lg sm:text-xl md:text-2xl">Join us to shape the future of education!</p>
          </div>


        </div>

        <ToastContainer position="top-center" autoClose={3000} />

        {/* Form */}
        <h2 className="text-2xl sm:text-3xl font-semibold text-white text-center py-4 rounded-t-lg bg-[#00BFA5] mt-10">
          Teacher Recruitment Application
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          {[
            { field: "name", type: "text", placeholder: "Enter full name" },
            { field: "email", type: "email", placeholder: "Enter email address" },
            { field: "phone", type: "tel", placeholder: "Enter phone number" },
            { field: "qualification", type: "text", placeholder: "Enter highest qualification" },
            { field: "experience", type: "number", placeholder: "Enter years of experience" },
            { field: "subject", type: "text", placeholder: "Enter subject expertise" },
            { field: "address", type: "text", placeholder: "Enter residential address" }
          ].map(({ field, type, placeholder }) => (
            <div className="flex flex-col relative" key={field}>
              <label
                htmlFor={field}
                className="text-sm sm:text-base font-medium text-gray-600 mb-1 capitalize"
              >
                {field}
              </label>
              <input
                type={type}
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={placeholder}
                required
                className="w-full px-4 py-2 border-b-2 border-gray-300 focus:border-[#00BFA5] outline-none transition-all duration-300"
              />
            </div>
          ))}

          {/* Resume Upload */}
          <div className="flex flex-col relative">
            <label
              htmlFor="resume"
              className="text-sm sm:text-base font-medium text-gray-600 mb-1"
            >
              Upload Resume
            </label>
            <input
              type="file"
              id="resume"
              name="resume"
              onChange={handleChange}
              accept=".pdf,.doc,.docx"
              required
              className="w-full px-4 py-2 border-b-2 border-gray-300 focus:border-[#00BFA5] outline-none transition-all duration-300"
            />
          </div>

          {/* Submit Button */}
          <motion.button
            type="submit"
            className={`w-full sm:w-auto mx-auto py-3 px-6 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 ${loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#00BFA5] hover:bg-[#00897B] text-white"
              }`}
            disabled={loading}
            whileTap={{ scale: 0.98 }}
          >
            {loading ? "Submitting..." : "Submit Application"}
          </motion.button>
        </form>
      </motion.div>
      <ToastContainer />
    </div>
  );
};

export default TeacherApplicationForm;
